import { config } from "config";

export const environment = {
  production: true,
  apiURL: config.prodApiUrl,
  syncFusionLicense: config.syncFusionLicense,
  appVersion: '1.1.0',
  enableDatabaseCopy: false,
  features: {
    calendar: false,
  },
};
